export default "__VITE_ASSET__BiY8dIHZ__"